import {acceptHMRUpdate, defineStore} from 'pinia';

type Position = 'center' | 'top-right' | 'top-left';

type Shape = 'spinner' | 'dots' | 'ring' | 'ball' | 'bars' | 'infinity';

interface State {
    isLoading: boolean;
    hasShadow: boolean;
    position: Position;
    shape: Shape;
}

export const useLoadingStore = defineStore('loading', {
    state: (): State => {
        return {
            isLoading: false,
            hasShadow: false,
            position: 'center',
            shape: 'infinity',
        };
    },
    actions: {
        start(
            position: Position = 'center',
            hasShadow = true,
            shape: Shape = 'spinner'
        ) {
            this.$patch({
                position,
                shape,
                hasShadow,
                isLoading: true,
            });
        },

        startSpinner() {
            this.start('top-left', false, 'spinner');
        },

        startInfinity() {
            this.start('top-left', false, 'infinity');
        },

        startBlock() {
            this.start('center', true, 'infinity');
        },

        end() {
            this.isLoading = false;
        },

        async loadAsync(promise: () => Promise<void>) {
            this.start();
            await promise();
            this.end();
        },
    },
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useLoadingStore, import.meta.hot));
}
